import axios from "axios";
import ENDPOINT from "../../context/EndPoint";

// A single user's detailed answers for a mock-test paper.
const GetUserTestDetail = async ({ payload }) => {
  const data = new FormData();
  data.append("session", payload.session);
  data.append("test_code", payload.test_code);
  data.append("user_id", payload.user_id);

  const res = await axios.post(ENDPOINT + "admin-get-user-test-detail.php", data, {
    headers: { "content-type": "multipart/form-data" },
  });
  return res ? res.data : null;
};

export default GetUserTestDetail;
